module.exports = __webpack_public_path__ + "static/Update-Toast-ec258c8420ada2f9d0def2257465692f.png";